(function() {
  if (window.ecCalculadoraInitialized) {
    return;
  }
  window.ecCalculadoraInitialized = true;

  function formatMoney(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      var fmt = (window.Shopify.money_format || '').trim();
      if (fmt) return Shopify.formatMoney(cents, fmt);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function initCalculadora(blockId) {
    const calculadora = document.querySelector(`.ec-calculadora[data-block-id="${blockId}"]`);
    if (!calculadora) {
      setTimeout(() => initCalculadora(blockId), 100);
      return;
    }

    const larguraInput = calculadora.querySelector(`#ec-calculadora-largura-${blockId}`);
    const alturaInput = calculadora.querySelector(`#ec-calculadora-altura-${blockId}`);
    const productForm = calculadora.querySelector('product-form');

    if (!larguraInput || !alturaInput || !productForm) {
      setTimeout(() => initCalculadora(blockId), 100);
      return;
    }

    const form = productForm.querySelector('form');
    if (!form) {
      setTimeout(() => initCalculadora(blockId), 100);
      return;
    }

    const unitPrice = parseInt(calculadora.getAttribute('data-unit-price') || '0', 10);
    const sectionId = calculadora.getAttribute('data-section-id') || '';

    // Move the buy-buttons error message out of the narrow button cell so it
    // renders full-width below the calculator form (instead of overflowing
    // beside the "Add to cart" button). Keep product-form's internal reference
    // pointing at the relocated node so validation messages still work.
    const errorWrapper = productForm.querySelector('.product-form__error-message-wrapper');
    const errorHost = calculadora.querySelector('.ec-calculadora-content__title') || calculadora;
    if (errorWrapper && errorHost && errorWrapper.parentElement !== errorHost) {
      errorHost.appendChild(errorWrapper);
      productForm.errorMessageWrapper = errorWrapper;
      productForm.errorMessage = errorWrapper.querySelector('.product-form__error-message');
    }

    let quantityInput = form.querySelector('input[name="quantity"]');
    if (!quantityInput) {
      quantityInput = document.createElement('input');
      quantityInput.type = 'hidden';
      quantityInput.name = 'quantity';
      quantityInput.value = '1';
      form.appendChild(quantityInput);
    }

    let alturaPropertyInput = form.querySelector('input[name="properties[Altura]"]');
    if (!alturaPropertyInput) {
      alturaPropertyInput = document.createElement('input');
      alturaPropertyInput.type = 'hidden';
      alturaPropertyInput.name = 'properties[Altura]';
      form.appendChild(alturaPropertyInput);
    }

    let larguraPropertyInput = form.querySelector('input[name="properties[Largura]"]');
    if (!larguraPropertyInput) {
      larguraPropertyInput = document.createElement('input');
      larguraPropertyInput.type = 'hidden';
      larguraPropertyInput.name = 'properties[Largura]';
      form.appendChild(larguraPropertyInput);
    }

    let squareFeetPropertyInput = form.querySelector('input[name="properties[_Square feets]"]');
    if (!squareFeetPropertyInput) {
      squareFeetPropertyInput = document.createElement('input');
      squareFeetPropertyInput.type = 'hidden';
      squareFeetPropertyInput.name = 'properties[_Square feets]';
      form.appendChild(squareFeetPropertyInput);
    }

    let isCalculadoraPropertyInput = form.querySelector('input[name="properties[is_calculadora]"]');
    if (!isCalculadoraPropertyInput) {
      isCalculadoraPropertyInput = document.createElement('input');
      isCalculadoraPropertyInput.type = 'hidden';
      isCalculadoraPropertyInput.name = 'properties[_is_calculadora]';
      form.appendChild(isCalculadoraPropertyInput);
    }

    function calculateSquareFeet() {
      const largura = parseFloat(larguraInput.value) || 0;
      const altura = parseFloat(alturaInput.value) || 0;
      const squareFeet = largura * altura;
      return Math.ceil(squareFeet);
    }

    function isValidInput() {
      const largura = parseFloat(larguraInput.value);
      const altura = parseFloat(alturaInput.value);
      return largura > 0 && altura > 0 && !isNaN(largura) && !isNaN(altura);
    }

    function applyPriceToContainer(container, formatted) {
      if (!container) return;
      const saleEl = container.querySelector('.price-item--last, .price-item--sale:not(s)');
      if (saleEl) { saleEl.textContent = formatted; return; }
      const regularEl = container.querySelector('.price-item--regular:not(s)');
      if (regularEl) regularEl.textContent = formatted;
    }

    function updatePriceDisplay() {
      if (unitPrice <= 0) return;
      const qty = calculateSquareFeet();
      if (qty <= 0) return;
      const formatted = formatMoney(qty * unitPrice);
      applyPriceToContainer(document.getElementById('price-' + sectionId), formatted);
      document.querySelectorAll('.ec-title-price-mobile').forEach(el => applyPriceToContainer(el, formatted));
    }

    function updateQuantity() {
      const quantity = calculateSquareFeet();
      if (quantity > 0) {
        quantityInput.value = quantity;
      }
    }

    function updateProperties() {
      if (isValidInput()) {
        const largura = parseFloat(larguraInput.value);
        const altura = parseFloat(alturaInput.value);
        const squareFeet = calculateSquareFeet();

        alturaPropertyInput.value = altura.toString();
        larguraPropertyInput.value = largura.toString();
        squareFeetPropertyInput.value = squareFeet.toString();
        isCalculadoraPropertyInput.value = 'Sim';
      } else {
        alturaPropertyInput.value = '';
        larguraPropertyInput.value = '';
        squareFeetPropertyInput.value = '';
        isCalculadoraPropertyInput.value = '';
      }
    }

    function syncSubmitWithProductForm() {
      document.dispatchEvent(new CustomEvent('product-form:validate'));
    }

    function handleInputChange() {
      updateQuantity();
      updateProperties();
      syncSubmitWithProductForm();
      updatePriceDisplay();
    }

    larguraInput.addEventListener('input', handleInputChange);
    larguraInput.addEventListener('change', handleInputChange);
    alturaInput.addEventListener('input', handleInputChange);
    alturaInput.addEventListener('change', handleInputChange);

    syncSubmitWithProductForm();

    const submitButton = form.querySelector('[type="submit"]');
    if (submitButton) {
      submitButton.addEventListener('click', function(e) {
        if (typeof productForm.isFormValid === 'function' && !productForm.isFormValid()) {
          e.preventDefault();
          e.stopImmediatePropagation();
          if (typeof productForm.validateRequiredOptions === 'function') {
          productForm.validateRequiredOptions();
        } else if (typeof productForm.refreshValidationMessage === 'function') {
          productForm.refreshValidationMessage();
        }
          return false;
        }
        const quantity = calculateSquareFeet();
        quantityInput.value = quantity;
        updateProperties();
      }, true);
    }

    form.addEventListener('submit', function(e) {
      if (typeof productForm.isFormValid === 'function' && !productForm.isFormValid()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (typeof productForm.validateRequiredOptions === 'function') {
          productForm.validateRequiredOptions();
        } else if (typeof productForm.refreshValidationMessage === 'function') {
          productForm.refreshValidationMessage();
        }
        return false;
      }
      const quantity = calculateSquareFeet();
      quantityInput.value = quantity;
      updateProperties();
    }, true);
  }

  function initAllCalculadoras() {
    const calculadoras = document.querySelectorAll('.ec-calculadora[data-block-id]');
    calculadoras.forEach(function(calculadora) {
      if (calculadora.classList.contains('ec-calculadora-mesa')) return;
      const blockId = calculadora.getAttribute('data-block-id');
      if (blockId) {
        initCalculadora(blockId);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllCalculadoras);
  } else {
    initAllCalculadoras();
  }
})();
